const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.pickdengu.mw";

const request = async <T>(path: string, options?: RequestInit): Promise<T> => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(options?.headers || {}),
    },
    ...options,
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.message || "Meta review request failed.");
  }

  return data as T;
};

export type WhatsAppBusinessProfile = {
  businessName: string;
  wabaId: string;
  phoneNumberId: string;
  displayPhoneNumber: string;
  verifiedName: string;
  qualityRating: string;
  status: string;
};

export type WhatsAppMessageResult = {
  messageId: string;
  recipient: string;
  templateName: string;
  status: string;
};

export type MetaCatalogProduct = {
  id: string;
  name: string;
  retailerId?: string;
  price: string;
  availability: string;
};

export type MetaCatalogResult = {
  catalogId: string;
  catalogName: string;
  products: MetaCatalogProduct[];
};

export const fetchWhatsAppBusinessProfile = () => {
  return request<WhatsAppBusinessProfile>(
    "/api/v1/meta-review/whatsapp/profile",
  );
};

export const sendWhatsAppReviewTemplate = (payload: {
  recipientPhoneNumber: string;
  templateName: string;
  languageCode: string;
}) => {
  return request<WhatsAppMessageResult>(
    "/api/v1/meta-review/whatsapp/send-template",
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );
};

export const fetchMetaCatalogProducts = () => {
  return request<MetaCatalogResult>("/api/v1/meta-review/catalog/products");
};

export const createMetaReviewProduct = () => {
  return request<MetaCatalogProduct>("/api/v1/meta-review/catalog/products", {
    method: "POST",
  });
};